import React from "react";
import ReactNumeric from "react-numeric";

export default function Input (props) {
  return (
    <ReactNumeric
      value={props.value}
      onChange={(event, value) => props.onChange(value)} 
      allowDecimalPadding= {false}
      digitGroupSeparator= " " 
      placeholder={props.placeholder}
      />
  );
}
